import React from 'react';
const ShurikenDot = _ref => {
  let {
    cx,
    cy,
    color
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    x: cx - 6.5,
    y: cy - 6,
    width: "13",
    height: "12",
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3125 5.97058L8.48407 7.79901L6.65565 11.6274L4.82722 7.79901L0.998792 5.97058L4.82722 4.14215L6.65565 0.313727L8.48407 4.14215L12.3125 5.97058Z",
    fill: color
  }));
};
export default ShurikenDot;